<template>
  <div id="popup-container">
    <v-toolbar dark color="primary">
      <v-toolbar-title class="heading-title"> Send Email </v-toolbar-title>
      <v-spacer></v-spacer>
      <v-btn fab x-small class="close" @click="closePanel">
        <v-icon dark color="white">fa-times</v-icon>
      </v-btn>
    </v-toolbar>
    <v-container>
      <v-row>
        <v-col md="12">
          <v-form>
            <v-container style="padding: 0px !important">
              <v-text-field
                :error-messages="messages.subject"
                v-model="email.subject"
                label="Mail Subject"
                type="text"
                filled
                class="input-width"
              ></v-text-field>
              <v-text-field
                :error-messages="messages.email"
                v-model="email.email"
                label="Email Address"
                type="text"
                filled
                class="input-width"
              ></v-text-field>
              <!--<div id="app">-->
              <div id="editor">
                <vue-editor
                  :error-messages="messages.content"
                  v-model="email.content"
                  placeholder="Type you email content here"
                  :editor-toolbar="customToolbar"
                ></vue-editor>
              </div>
              <div id="result_content">
                <div v-html="content"></div>
              </div>
              <!--</div>-->
            </v-container>
          </v-form>
        </v-col>
      </v-row>
    </v-container>
    <v-footer absolute height="68">
      <v-flex px-4 py-4 text-right>
        <v-btn
          v-if="!loading"
          color="grey300"
          class="cancel-button"
          @click="closePanel"
          >Cancel</v-btn
        >
        <v-btn v-if="loading" color="primary" loading></v-btn>
        <v-btn
          v-else
          color="primary"
          class="ml-4 add-course-button"
          @click="sendEmail"
          >Send Email</v-btn
        >
      </v-flex>
    </v-footer>
  </div>
</template>
<script>
import { EventBus } from '@/event-bus.js';
import managerAPI from '@/api/manager.js';
import Quill from 'quill';
import { ImageDrop } from 'quill-image-drop-module';
Quill.register('modules/imageDrop', ImageDrop);
// const fonts = Quill.import('formats/font')

export default {
  props: {
    emailAddress: {
      type: String,
      default: 'demo@perituslearning.co.uk',
    },
  },
  watch: {
    emailAddress() {
      this.email.email = this.$props.emailAddress;
    },
  },
  data: () => ({
    editorSettings: {
      modules: {
        imageDrop: true,
      },
    },
    content: '',
    customToolbar: [
      [{ header: [false, 1, 2, 3, 4, 5, 6] }],
      ['bold', 'italic'],
      [
        { align: '' },
        { align: 'center' },
        { align: 'right' },
        { align: 'justify' },
      ],
      [{ list: 'ordered' }, { list: 'bullet' }],
      ['link'],
      [{ 'font':[] }],
      // [{ 'font':[ fonts.whitelist] }],
    ],
    messages: {},
    email: {},
    successMessage: 'Email Sent Successfully.',
    errorMessage:
      'Oops, something went wrong! Please check information is correct.',
    loading: false,
  }),
  created() {
    this.email.email = this.emailAddress;
  },
  methods: {
    closePanel() {
      this.$emit('closePanel', {});
    },
    sendEmail() {
      this.loading = true;
      managerAPI
        .sendEmail(this.email)
        .then(() => {
          this.closePanel();
          EventBus.$emit('EMAIL_SENT', this.params);
          this.$snotify.success(this.successMessage);
          this.loading = false;
          setTimeout(() => {
                this.$gf.removeBackdrop();
            },300);
        })
        .catch((err) => {
          this.valid = false;
          this.$snotify.error(this.errorMessage);
          this.messages = this.$gf.errorResponse(err);
          this.loading = false;
          setTimeout(() => {
                this.$gf.removeBackdrop();
            },300);
        });
    },
  },
};
</script>
<style>
#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: left !important;
  color: #2c3e50;
  margin-top: 60px;
}
.quillWrapper .ql-snow.ql-toolbar {
  padding: 2px !important;
}
#editor {
  width: 93%;
}
</style>
